const serviceEndpoints = {
  markMyDayEndPoint: "/api/meeting/markDayForActivity",
  tagRegularizeMeetingEndpoint: "/api/meeting/tag",
  searchImdsEndpoint: "/api/meeting/searchImds",
  getRegularisationDatesEndpoint: "/api/meeting/getRegularisationDates",
  addConveyanceEndpoint: "/api/meeting/addConveyance",
  searchMeetingEndpoint: "/api/meeting/search",
  logoutEndpoints: "/api/auth/logout",
  loginEndpoints: "/api/auth/login",
  forgotPasswordEndpoints: "/api/auth/forgotPassword",
  resetPasswordEndpoints: "/api/auth/resetPassword",
  createUser: "/api/user/create",
  fetchManagerList: "/api/user/reporting-manager/search",
  fetchUserEmailList: "/api/user/search/by-email",
  fetchUserDetails: "/api/user/details",
  deleteUserEndpoints: "/api/user/delete",
  downloadImdsFileTemplateEndpoint: "/api/meeting/download-template",
  uploadImdsFileEndpoint: "/api/meeting/upload-imd",
};

export default serviceEndpoints;
